var generateStyle = function generateStyle(componentTheme) {
  return {
    optionsInput: {
      margin: "".concat(componentTheme.optionsInputMargin, " 0"),
      width: '100%',
      '> input': {
        boxSizing: 'border-box',
        width: '100%',
        fontSize: componentTheme.optionsInputFontSize,
        fontWeight: componentTheme.optionsInputFontWeight,
        borderRadius: componentTheme.optionsInputBorderRadius,
        marginTop: componentTheme.optionsInputConditionalMargin,
        padding: componentTheme.optionsInputPadding,
        paddingRight: 0
      },
      '&:focus > input': {
        backgroundColor: componentTheme.optionsInputFocusBackColor,
        color: componentTheme.optionInputFocusColor
      }
    },
    optionsInputCheckbox: {
      display: 'block',
      margin: "".concat(componentTheme.optionsInputCheckbox, " 0")
    }
  };
};
export default generateStyle;